<div class="center">
    <mat-card id = "style-4" class="cardcomponentMasks">
        <div class="arx-calendar">
            <iframe width="1500" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiMDE1ZTIwNzAtNTkzZi00ZmQ5LWI0YWItYzI2M2MxMTY5NTM5IiwidCI6IjMyZjEwMmZlLTQ3MTgtNGJlMS1hNWMzLTIxNzAyOTkwOTA1NCIsImMiOjl9&amp;pageName=ReportSection" frameborder="0" allowfullscreen="true"></iframe>
        </div>
    </mat-card>
</div>


